import assignmentsView from './assignmentsView'
import personalPanel from './personalPanel'
import storiesView from './storiesView'
import weekView from './weekView'

export default {
  assignmentsView,
  personalPanel,
  storiesView,
  weekView,
}
